import React from 'react';
import { useSafeContext } from '../hooks/use-safe-context';
import { SharedConfigurationsResult } from '../types/shared-configs';


export const SharedConfigsContext = React.createContext<
  SharedConfigurationsResult | undefined
>(undefined);

export function useSharedConfigs(): SharedConfigurationsResult {
  return useSafeContext(SharedConfigsContext, 'SharedConfigs');
}
